<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title>{{ "RELEASENOTES.HEADER" | translate }} - {{ releasenotesHeader | translate }}</mat-card-title>
            <ng-container *ngIf="releaseNotes.length >= 1">
                <button mat-raised-button class="download-btn" (click)="downloadAll()">
                    <div class="btn-content">
                        <mat-progress-spinner
                            *ngIf="pdfLoading"
                            diameter="20"
                            mode="indeterminate"
                            color="accent"
                            class="spinner-centered"
                        ></mat-progress-spinner>
                        <span class="download-text" [class.invisible]="pdfLoading">
                            {{ "RELEASENOTES.DOWNLOAD" | translate }}
                        </span>
                    </div>
                </button>
            </ng-container>
        </mat-card-title-group>

        <mat-card-content>
            <div class="home-card" id="content">
                <div>
                    <ng-container *ngIf="releaseNotes.length == 0 && !this.error">
                        {{ "RELEASENOTES.INFO" | translate }}
                    </ng-container>
                    <ng-container *ngIf="this.error">
                        {{ "RELEASENOTES.ERROR" | translate }}
                    </ng-container>
                    <ng-container *ngFor="let release of releaseNotes">
                        <button mat-stroked-button class="line-btn" (click)="toggleBtn(releaseNotes.indexOf(release))">
                            {{ release.releaseName }}
                            <mat-icon iconPositionEnd>{{
                                this.expandedArray[releaseNotes.indexOf(release)] ? "expand_less" : "expand_more"
                            }}</mat-icon>
                        </button>
                        <div *ngIf="this.expandedArray[releaseNotes.indexOf(release)]" class="release">
                            <div class="meta-release">
                                <p *ngIf="release.info.datetime != ''">
                                    {{ "RELEASENOTES.DATE" | translate }}: {{ release.info.datetime | date : "dd.MM.yyyy" }}
                                </p>
                                <p *ngIf="release.info.author != ''">{{ "RELEASENOTES.AUTHOR" | translate }}: {{ release.info.author }}</p>
                            </div>
                            <p *ngIf="release.description != ''">{{ release.description }}</p>
                            <mat-accordion class="release">
                                <mat-expansion-panel
                                    *ngFor="let comp of release.componentVersions"
                                    (opened)="loadComponent(comp.componentName)"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="title"> {{ comp.componentName }} </mat-panel-title>
                                        <mat-panel-description class="description">
                                            {{ comp.versionTag[0] }}
                                            <mat-chip *ngIf="comp.changed == false" class="unchanged">{{
                                                "RELEASENOTES.LABEL.UNCHANGED" | translate
                                            }}</mat-chip>
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <ng-container *ngIf="!loaded">
                                        <div class="loading">
                                            <mat-progress-spinner mode="indeterminate" color="primary" diameter="35"></mat-progress-spinner>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="errorComp">
                                        {{ "RELEASENOTES.ERROR_COMP" | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="loaded && !errorComp">
                                        <ng-container *ngIf="components != undefined">
                                            <ng-container *ngFor="let tag of comp.versionTag; let last = last">
                                                <ng-container *ngFor="let version of components.versions">
                                                    <ng-container *ngIf="version.versionTag == tag" class="container">
                                                        <div class="version" [class.last-item]="last">
                                                            <div class="meta">
                                                                <p *ngIf="comp.versionTag.length > 1" class="version-tag">{{ tag }}</p>
                                                                <p>
                                                                    {{ "RELEASENOTES.DATE" | translate }}:
                                                                    {{ version.versionInfo.datetime | date : "dd.MM.yyyy" }}
                                                                </p>
                                                                <p *ngIf="version.versionInfo.author != ''">
                                                                    {{ "RELEASENOTES.AUTHOR" | translate }}:
                                                                    {{ version.versionInfo.author }}
                                                                </p>
                                                                <div *ngFor="let label of version.versionInfo.labels" class="label">
                                                                    <mat-chip
                                                                        [ngClass]="{
                                                                            'security-label': label == 'security',
                                                                            'bugfix-label': label == 'bugfix',
                                                                            'feature-label': label == 'feature',
                                                                            'improvement-label': label == 'improvement'
                                                                        }"
                                                                        >{{ label }}</mat-chip
                                                                    >
                                                                </div>
                                                            </div>
                                                            <ng-container *ngIf="components.metadata.type == 'componentWithSubVersions'">
                                                                <div class="subversions-container">
                                                                    <div class="subversions">
                                                                        <ng-container *ngFor="let sub of version.subVersions">
                                                                            <div class="subversions-version-container">
                                                                                <div class="subversions-version">
                                                                                    <p>{{ sub.subVersionName }}:</p>
                                                                                    <p>{{ sub.subVersionTag }}</p>
                                                                                </div>
                                                                            </div>
                                                                        </ng-container>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                            <div class="notes">
                                                                <div class="feature" *ngIf="version.versionNotes.features.length > 0">
                                                                    <p class="header">{{ "RELEASENOTES.FEATURE" | translate }}</p>
                                                                    <mat-list class="list">
                                                                        <mat-list-item *ngFor="let item of version.versionNotes.features">
                                                                            <div matLine>&bull; {{ item }}</div>
                                                                        </mat-list-item>
                                                                    </mat-list>
                                                                </div>
                                                                <div
                                                                    class="improvement"
                                                                    *ngIf="version.versionNotes.improvements.length > 0"
                                                                >
                                                                    <p class="header">{{ "RELEASENOTES.IMPROVEMENT" | translate }}</p>
                                                                    <mat-list class="list">
                                                                        <mat-list-item
                                                                            *ngFor="let item of version.versionNotes.improvements"
                                                                        >
                                                                            <div matLine>&bull; {{ item }}</div>
                                                                        </mat-list-item>
                                                                    </mat-list>
                                                                </div>
                                                                <div class="bugfix" *ngIf="version.versionNotes.bugfixes.length > 0">
                                                                    <p class="header">{{ "RELEASENOTES.BUGFIX" | translate }}</p>
                                                                    <mat-list class="list">
                                                                        <mat-list-item *ngFor="let item of version.versionNotes.bugfixes">
                                                                            <div matLine>&bull; {{ item }}</div>
                                                                        </mat-list-item>
                                                                    </mat-list>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </ng-container>
                </div>
            </div>
        </mat-card-content>
    </div>
</mat-card>
